import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[equalTo]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EqualToValidator, multi: true }
    ],
    standalone: false
})
export class EqualToValidator  extends BaseValidator implements OnChanges {

  @Input('equalTo')
  otherValue: string;

  @Input('equalTo_comparisonType')
  comparisonType: string;

  @Input('equalTo_fieldName')
  fieldName: string;

  @Input('equalTo_validationMessage')
  validationMessage: string;

  constructor() {
    super('equalTo');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (!control.value || !this.otherValue) {
      return null;
    }

    let firstValue: any = control.value;
    let secondValue: any = this.otherValue;
    if (this.comparisonType === "Date") {
      firstValue = new Date(control.value);
      secondValue = new Date(this.otherValue);
    }

    if (firstValue == secondValue)
      return null;

    var result = { fieldName: this.fieldName } as any;
    if (this.validationMessage) {
      result.error = this.validationMessage;
    }

    return this.buildValidationErrorResult(result);
  }
}
